import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Card, Image, Header } from 'semantic-ui-react';
import i18next from 'i18next';
import { fetchChain } from '../../../actions';
import { getCurrentChain } from '../../../selectors';

import './Chain.scss';

const Chain = (props) => {
    const chainId = useSelector(state => state.businessApp.chainId);
    const chain = useSelector(state => getCurrentChain(state));
    const dispatch = useDispatch();

    useEffect(() => {
        if (chain && !chain.name) {
            dispatch(fetchChain(chainId));
        }
    }, [chainId]);

    return (
        <div className="pi chain">
            <Header.Content className="header">{`${i18next.t('chainPage.welcome', { name: chain.name })}`}</Header.Content>

            <Card.Group centered>
                <Card className="option-card" as={Link} to={`/chain/${chain.id}/restaurants`}>
                    <Image src='https://www.perforce.com/sites/default/files/image/2018-11/image-blog-8-tips-effective-branch-management_0.jpg' wrapped ui={false} size='large' />
                    <Card.Content>
                        <Card.Header>{i18next.t('chain.actions.branchManagement')}</Card.Header>
                    </Card.Content>
                    <Card.Content extra>
                        <Card.Meta>{i18next.t('chain.actions.branchManagementDescription')}</Card.Meta>
                    </Card.Content>
                </Card>

                <Card className="option-card" as={Link} to={`/chain/${chain.id}/website`}>
                    <Image src='https://www.emeraldskygroup.com/wp-content/uploads/2019/01/web-development.png' wrapped ui={false} size='large' />
                    <Card.Content>
                        <Card.Header>{i18next.t('chain.actions.websiteManagement')}</Card.Header>
                    </Card.Content>
                    <Card.Content extra>
                        <Card.Meta>{i18next.t('chain.actions.websiteManagementDescription')}</Card.Meta>
                    </Card.Content>
                </Card>

                <Card className="option-card" as={Link} to={`/chain/${chain.id}/marketing`}>
                    <Image src='https://www.des-madrid.com/app/uploads/Know-the-most-useful-digital-marketing-tool-2.png' wrapped ui={false} size='large' />
                    <Card.Content>
                        <Card.Header>{i18next.t('chain.actions.marketingTool')}</Card.Header>
                    </Card.Content>
                    <Card.Content extra>
                        <Card.Meta>{i18next.t('chain.actions.marketingToolDescription')}</Card.Meta>
                    </Card.Content>
                </Card>
            </Card.Group>
        </div>
    );
};

Chain.propTypes = {
    chain: PropTypes.object,

};

export default Chain;